import { render, staticRenderFns } from "./orderDetailModal.vue?vue&type=template&id=37c9ef57&scoped=true"
import script from "./orderDetailModal.vue?vue&type=script&lang=js"
export * from "./orderDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9ef57",
  null
  
)

export default component.exports